// extracted by mini-css-extract-plugin
export var active = "_f5-2";
export var recordingDot = "_f5-1";
export var recordingIndicator = "_f5-0";